import { Injectable } from '@angular/core';
import { MortgageInsuranceService } from "@core/services/mortgage-insurance/mortgage-insurance.service";
import { NavigationService } from '@core/services/navigation/navigation.service';
import { ModalController } from "@ionic/angular";
import {
  MortgageInsuranceRequestSuccessComponent
} from "@modals/mortgage-insurance-request-success/mortgage-insurance-request-success.component";
import { BaseProductCommand } from '@shared/commands/base-product.command';
import { ICreditCommandContext, IProductCommandContext } from '@shared/models/command';
import { ProductTypes } from '@shared/models/products.model';
import { CommandAvailabilityService } from '@shared/services/command-availability.service';
import { Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class MortgageInsuranceCommand extends BaseProductCommand {
  readonly type = 'renew-insurance';
  readonly title = 'Продлить действие страховки';
  readonly icon = 'maintenance';
  readonly productType = ProductTypes.CREDIT;
  readonly isInfoAction = false;
  readonly settingsNames = undefined;
  readonly order = 3; // Третий в actions для credit

  constructor(
    private navigationService: NavigationService,
    commandAvailabilityService: CommandAvailabilityService,
    private mortgageInsuranceService: MortgageInsuranceService,
    private modalCtrl: ModalController,
  ) {
    super(commandAvailabilityService);
  }

  async execute(context: IProductCommandContext): Promise<void> {
    if(this.mortgageInsuranceService.isInsuranceRequestCompleted(context.data)) {
      this.modalCtrl
        .create({
          component: MortgageInsuranceRequestSuccessComponent,
          handle: false,
          initialBreakpoint: 1,
          cssClass: 'custom',
          backdropDismiss: false,
          componentProps: {
            modal: this,
            staticHeight: true,
          }
        })
        .then((modal) => {
          modal.present();
        });
    } else {
      this.navigationService.push(`/mortgage-insurance/${context.data.id}`)
    }
  }

  protected checkAdditionalAvailability(context: ICreditCommandContext): Observable<boolean> | boolean {
    return !!context.data?.creditInsuranceList && this.mortgageInsuranceService.isInsuranceExpired(context.data);
  }
}
